"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ConfirmationDialog = _interopRequireDefault(require("../objects/ConfirmationDialog"));
var _constants = require("../../constants");
var _AuInput = _interopRequireWildcard(require("./AuInput"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _Tabs = _interopRequireDefault(require("./Tabs"));
var _context, _context2, _context3, _context4;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "dialog": "custom_auth-module__dialog___VcQBL",
  "input_container": "custom_auth-module__input_container___rJm4h",
  "secret_input_container": "custom_auth-module__secret_input_container___zgHey custom_auth-module__input_container___rJm4h",
  "input_container_token": "custom_auth-module__input_container_token___SJf2y custom_auth-module__input_container___rJm4h",
  "input": "custom_auth-module__input___CF5GS",
  "container": "custom_auth-module__container___gq3On",
  "using_client": "custom_auth-module__using_client___LiDdu",
  "text": "custom_auth-module__text___Na5sI",
  "text_secret": "custom_auth-module__text_secret___TLDEr custom_auth-module__text___Na5sI",
  "body": "custom_auth-module__body___lJJAF",
  "header": "custom_auth-module__header___CnFxm",
  "au_header": "custom_auth-module__au_header___Szt0c",
  "tmc_header": "custom_auth-module__tmc_header___AUOUe",
  "header_icon": "custom_auth-module__header_icon___zbSV7",
  "outer_container": "custom_auth-module__outer_container___GO3go",
  "buttons": "custom_auth-module__buttons___aWWLH",
  "tabs": "custom_auth-module__tabs___d1wRB",
  "no_tabs": "custom_auth-module__no_tabs___DvAil",
  "text_area": "custom_auth-module__text_area___mkOuI",
  "error": "custom_auth-module__error___Zvpw1"
};
function validateInput(inputVal, fieldDisplayId) {
  if (!inputVal) {
    return {
      fieldDisplayId,
      errDisplayId: 'au.customCredentials.requiredError'
    };
  }
  if ((0, _includes.default)(fieldDisplayId).call(fieldDisplayId, 'token')) {
    return /^(?:[\w-]*\.){2}[\w-]*$/.test(inputVal) ? null : {
      fieldDisplayId,
      errDisplayId: 'au.customCredentials.invalidError'
    };
  }
  if ((0, _includes.default)(fieldDisplayId).call(fieldDisplayId, 'clientId')) {
    return inputVal.length < 256 ? null : {
      fieldDisplayId,
      errDisplayId: 'au.customCredentials.invalidError'
    };
  }
  if ((0, _includes.default)(fieldDisplayId).call(fieldDisplayId, 'clientSecret')) {
    return inputVal.length < 256 ? null : {
      fieldDisplayId,
      errDisplayId: 'au.customCredentials.invalidError'
    };
  }
  return null;
}

// NOTE: This is a WIP and is hidden behind a feature flag and is not intended
//       for regular customers and is purely a POC.

// TODO: localize
// TODO: add option for token only
// TODO: add username and password
class CustomAuth extends _react.Component {
  static propTypes = {
    onSubmit: T.func.isRequired,
    onCancel: T.func.isRequired,
    onNewToken: T.func,
    auth: T.func,
    tabs: T.array,
    initTab: T.oneOf(['client', 'token'])
  };
  static defaultProps = {
    onNewToken: _constants.NOOP,
    auth: _constants.NOOP,
    tabs: ['client', 'token'],
    initTab: 'client'
  };
  state = {
    tab: this.props.initTab,
    idError: null,
    secretError: null,
    tokenError: null,
    authConfig: null,
    inputText: {
      clientId: '',
      clientSecret: '',
      token: ''
    }
  };
  stopMaintaining() {
    if (this.state.authConfig) {
      this.state.authConfig.token.maintain = false; // eslint-disable-line react/no-direct-mutation-state
    }
  }

  componentWillUnmount() {
    this.stopMaintaining();
  }
  onAuth = (0, _bind.default)(_context = this.onAuth).call(_context, this);
  onAuth(authConfig) {
    this.stopMaintaining();
    this.setState({
      authConfig
    });
    this.props.onNewToken(authConfig.token);
  }
  auth = (0, _bind.default)(_context2 = this.auth).call(_context2, this);
  auth() {
    const {
      tabs
    } = this.props;
    const {
      inputText
    } = this.state;
    if (tabs.length !== 0) {
      let cbVal;
      switch (this.state.tab) {
        case 'client':
          {
            cbVal = this.props.onSubmit({
              clientId: inputText.clientId,
              clientSecret: inputText.clientSecret
            });
            break;
          }
        case 'token':
          {
            cbVal = this.props.onSubmit({
              token: inputText.token
            });
            break;
          }
      }
      if (cbVal instanceof _promise.default) {
        cbVal.catch(err => {
          if (err == "Cannot parse JWT string") {
            this.setState({
              tokenError: {
                showError: true,
                fieldDisplayId: 'au.customCredentials.token',
                errDisplayId: 'au.customCredentials.invalidError'
              }
            });
          }
          if (err.data) {
            err.data.status == "ACC-16-6011" || resp.data.status == "ACC-09-0009" ? this.setState({
              idError: {
                showError: true,
                fieldDisplayId: 'au.customCredentials.clientId',
                errDisplayId: 'au.customCredentials.invalidError'
              }
            }) : this.setState({
              secretError: {
                showError: true,
                fieldDisplayId: 'au.customCredentials.clientSecret',
                errDisplayId: 'au.customCredentials.invalidError'
              }
            });
          }
        });
      }
    } else {
      this.setState({
        isLoading: true
      }, () => this.props.onSubmit({
        ...this.state.inputText,
        base: this.props.base
      }, false).then(this.onAuth, resp => resp.data.status == "ACC-16-6011" || resp.data.status == "ACC-09-0009" ? this.setState({
        idError: {
          showError: true,
          fieldDisplayId: 'au.customCredentials.clientId',
          errDisplayId: 'au.customCredentials.invalidError'
        }
      }) : this.setState({
        secretError: {
          showError: true,
          fieldDisplayId: 'au.customCredentials.clientSecret',
          errDisplayId: 'au.customCredentials.invalidError'
        }
      })).finally(() => this.setState({
        isLoading: false
      })));
    }
  }
  onKeyDown = (0, _bind.default)(_context3 = this.onKeyDown).call(_context3, this);
  onKeyDown(e) {
    if (e.key === _constants.ENTER_KEY) {
      // enter
      this.props.auth();
    }
  }
  onChange(name, e) {
    let idError;
    let secretError;
    let tokenError;
    if (name == 'clientId') {
      idError = validateInput(e.target.value, 'au.customCredentials.clientId');
      this.setState({
        idError
      });
    }
    if (name == 'clientSecret') {
      secretError = validateInput(e.target.value, 'au.customCredentials.clientSecret');
      this.setState({
        secretError
      });
    }
    if (name == 'token') {
      tokenError = validateInput(e.target.value, 'au.customCredentials.token');
      this.setState({
        tokenError
      });
    }
    this.setState(prevState => {
      const inputText = {
        ...prevState.inputText
      };
      inputText[name] = e.target.value;
      return {
        inputText
      };
    });
  }
  onClear = (0, _bind.default)(_context4 = this.onClear).call(_context4, this);
  onClear() {
    this.setState(prevState => {
      const inputText = {
        ...prevState.inputText
      };
      let idError = prevState.idError;
      inputText.clientId = '';
      idError = validateInput(inputText.clientId, 'au.customCredentials.clientId');
      return {
        inputText,
        idError
      };
    });
  }
  handleFocusOut(name, e) {
    if (name == 'clientId') {
      this.setState({
        showClientIdError: true
      });
    }
    if (name == 'clientSecret') {
      this.setState({
        showClientSecretError: true
      });
    }
    if (name == 'token') {
      this.setState({
        showTokenError: true
      });
    }
  }
  renderInputs() {
    var _context5, _context6, _context7, _context8, _context9, _context10;
    const {
      tab,
      tokenError,
      idError,
      secretError,
      inputText,
      showClientIdError,
      showClientSecretError,
      showTokenError
    } = this.state;
    switch (tab) {
      case 'client':
        // TODO: remove placeholders and make keys
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)({
            [styles['no_tabs']]: this.props.tabs.length === 0
          }, styles.dialog)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: styles.input_container
        }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
          displayId: "au.clientId",
          className: (0, _classnames.default)({
            [styles.error]: idError && showClientIdError
          }, styles.text)
        }), /*#__PURE__*/_react.default.createElement(_AuInput.default, {
          type: "text",
          tabIndex: 900,
          onKeyDown: this.onKeyDown,
          name: "clientId",
          className: styles.input,
          showError: idError && showClientIdError,
          error: idError,
          onClear: this.onClear,
          onChange: (0, _bind.default)(_context5 = this.onChange).call(_context5, this, "clientId"),
          value: inputText.clientId,
          createMode: true,
          id: "clientId",
          onBlur: (0, _bind.default)(_context6 = this.handleFocusOut).call(_context6, this, 'clientId')
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: styles.secret_input_container
        }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
          displayId: "au.clientSecret",
          className: (0, _classnames.default)({
            [styles.error]: secretError && showClientSecretError
          }, styles.text_secret)
        }), /*#__PURE__*/_react.default.createElement(_AuInput.default, {
          type: _AuInput.INPUT_TYPE_PASSWORD,
          tabIndex: 901,
          onKeyDown: this.onKeyDown,
          name: "clientSecret",
          className: styles.input,
          showError: secretError && showClientSecretError,
          error: secretError,
          onChange: (0, _bind.default)(_context7 = this.onChange).call(_context7, this, "clientSecret"),
          value: inputText.clientSecret,
          createMode: true,
          id: "clientSecret",
          onBlur: (0, _bind.default)(_context8 = this.handleFocusOut).call(_context8, this, 'clientSecret')
        })));
      case 'token':
        return /*#__PURE__*/_react.default.createElement("div", {
          className: styles.dialog
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: styles.input_container_token
        }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
          displayId: "au.customCredentials.token",
          className: styles.text
        }), /*#__PURE__*/_react.default.createElement(_AuInput.default, {
          tabIndex: 1,
          key: "token",
          className: styles.text_area,
          onKeyDown: this.onKeyDown,
          onChange: (0, _bind.default)(_context9 = this.onChange).call(_context9, this, 'token'),
          value: this.state.token,
          showError: Boolean(tokenError) && showTokenError,
          error: tokenError,
          type: _AuInput.INPUT_TYPE_TEXTAREA,
          autoFocus: true,
          onBlur: (0, _bind.default)(_context10 = this.handleFocusOut).call(_context10, this, 'token')
        })));
    }
  }
  render() {
    const {
      tab,
      inputText,
      idError,
      secretError,
      tokenError
    } = this.state;
    const {
      tabs
    } = this.props;
    // TODO: handle isLoading

    const navTabs = (0, _map.default)(tabs).call(tabs, t => ({
      labelId: `au.customCredentials.tab.${t}`,
      selected: tab === t,
      onClick: () => this.setState({
        tab: t
      })
    }));
    return /*#__PURE__*/_react.default.createElement(_ConfirmationDialog.default, {
      onConfirm: this.auth,
      onCancel: this.props.onCancel,
      bodyClassName: styles.body,
      className: styles.outer_container,
      showCloseIcon: false,
      titleId: "au.loginWithConfidentialClient",
      headerClassName: styles.au_header,
      confirmDisplayId: "au.login",
      buttonsClassName: styles.buttons,
      confirmBtnDisabled: tab == 'client' ? inputText.clientId.length == 0 || idError !== null || inputText.clientSecret.length == 0 || secretError !== null : inputText.token.length == 0 || tokenError !== null
    }, tabs.length > 1 && /*#__PURE__*/_react.default.createElement(_Tabs.default, {
      className: styles.tabs,
      navLinks: navTabs
    }), this.renderInputs());
  }
}
exports.default = CustomAuth;